<template>
    <div>
        <div v-if="!!structures.length != 0">
            <b-form-checkbox v-model="internal"> Interno </b-form-checkbox>
            <br /><br />
            <app-form-select-input
                v-if="internal"
                label="Estructura"
                :options="structures"
                :hasError="$v.theVehicle.structureId.$error"
                errorMessage="Debe seleccionar la estructura"
                @change="$v.theVehicle.structureId.$touch() && getPeopleList"
                v-model="theVehicle.structureId"
                :required="true"
            />
            <app-form-select-input
                label="Tipo vehículo"
                :options="vehicleTypes"
                :hasError="$v.theVehicle.vehicleTypeId.$error"
                errorMessage="Debe seleccionar el tipo de vehículo"
                @change="$v.theVehicle.vehicleTypeId.$touch()"
                v-model="theVehicle.vehicleTypeId"
                :required="true"
            />
            <app-form-text-input
                label="Placa"
                id="plate"
                :required="true"
                :hasError="$v.theVehicle.plate.$error"
                errorMessage="Debe escribir la placa"
                @input="$v.theVehicle.plate.$touch()"
                v-model="theVehicle.plate"
            ></app-form-text-input>
            <app-form-text-input
                label="Marca"
                id="brand"
                v-model="theVehicle.brand"
            ></app-form-text-input>
            <app-autocomplete
                label="Propietario"
                v-model="owner"
                :items="people"
            ></app-autocomplete>
            <b-btn variant="link" size="sm" @click="onNewPeopleRequired"
                >Ir a crear personas</b-btn
            >
        </div>
        <div v-if="!structures.length != 0" class="alert alert-danger">
            <div>No hay estructuras asociadas</div>
        </div>
    </div>
</template>
<script>
import FormTextInput from '../../UI/Controls/Forms/FormTextInput.vue'
import FormSelectInput from '../../UI/Controls/Forms/FormSelectInput.vue'
import { required, numeric } from 'vuelidate/lib/validators'
import {
    alphaSpaces,
    alphaNumericNoSpaces,
} from '../../../utils/CustomValidators'
import structuresRepository from '../../../repositories/structures.repository.js'
import vehiclesRepository from '../../../repositories/vehicles.repository.js'
import { mapGetters } from 'vuex'

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
    },

    props: {
        myVehicle: {
            default: null,
        },
        myClient: {
            default: null,
        },
        onSave: {
            type: Function,
        },
    },

    data() {
        return {
            theVehicle: {
                structureId: '',
                clientId: '',
                vehicleTypeId: '',
                plate: '',
                brand: '',
                userId: '',
                internal: 0,
            },
            structures: [],
            internal: false,
            owner: null,
            people: [],
            search: '',
        }
    },

    validations() {
        let theVehicle
        if (!this.myVehicle && this.internal) {
            theVehicle = {
                clientId: { required },
                plate: { required, alphaNumericNoSpaces },
                vehicleTypeId: { required },
                structureId: { required },
            }
        } else if (!this.myVehicle && !this.internal) {
            theVehicle = {
                clientId: { required },
                plate: { required, alphaNumericNoSpaces },
                vehicleTypeId: { required },
            }
        } else if (this.myVehicle && this.internal) {
            theVehicle = {
                plate: { required, alphaNumericNoSpaces },
                clientId: { required },
                vehicleTypeId: { required },
                structureId: { required },
            }
        } else if (this.myVehicle && !this.internal) {
            theVehicle = {
                clientId: { required },
                plate: { required, alphaNumericNoSpaces },
                vehicleTypeId: { required },
            }
        }
        return { theVehicle }
    },

    watch: {
        myVehicle(val) {
            this.fillForm()
        },
        myClient(client) {
            this.loadStructures()
        },
        internal(val) {
            if (val) {
                this.theVehicle.internal = 1
            } else {
                this.theVehicle.internal = 0
            }
        },
        ['theVehicle.structureId'](val) {
            this.getPeopleList({ structureId: val })
            this.owner = null
        },
    },
    computed: {
        ...mapGetters(['vehicleTypes']),
    },
    methods: {
        onNewPeopleRequired() {
            this.$emit('close')
            this.$router.push({ name: 'peoplePageList' })
        },
        loadStructures() {
            const sr = Object.assign({}, structuresRepository)
            sr.all(this.myClient.id)
                .then((data) => {
                    this.structures = data
                    this.fillForm()
                })
                .catch((error) =>
                    toastr.error('Ocurrio un error al cargar los perfiles')
                )
        },
        registerVehicle() {
            this.theVehicle.clientId = this.myClient.id
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            this.theVehicle.userId = this.user.id

            const vr = Object.assign({}, vehiclesRepository)
            const personId = !!this.owner ? this.owner.id : ''
            const vehicleData = { ...this.theVehicle, personId }
            // vr.saveVehicle(this.theVehicle)
            vr.saveVehicle(vehicleData)
                .then((data) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        Object.keys(this.theVehicle).map(
                            (key) => (this.theVehicle[key] = '')
                        )
                        this.$v.$reset()
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch((error) => {
                    toastr.error('Ocurrió un error al guardar el vehículo')
                })
        },
        updateVehicle(id) {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const vr = Object.assign({}, vehiclesRepository)
            const vehicleData = {
                ...this.theVehicle,
                personId: this.owner.id ?? '',
            }
            vr.updateVehicle(vehicleData, this.myVehicle.id)
                .then((data) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        Object.keys(this.theVehicle).map(
                            (key) => (this.theVehicle[key] = '')
                        )
                        this.$v.$reset()
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch((error) => {
                    toastr.error('Ocurrió un error al actualizar el vehículo')
                })
        },
        SaveOrUpdate() {
            if (!!this.myVehicle) {
                this.updateVehicle()
            } else {
                this.registerVehicle()
            }
        },
        fillForm() {
            if (Object.keys(this.myVehicle).length !== 0) {
                this.theVehicle.clientId = this.myVehicle.client_id
                this.theVehicle.plate = this.myVehicle.plate
                this.theVehicle.brand = this.myVehicle.brand
                this.theVehicle.userId = this.myVehicle.user_id
                this.theVehicle.internal = this.myVehicle.internal
                this.internal = !!this.myVehicle.internal ? true : false
                this.$nextTick(() => {
                    this.theVehicle.vehicleTypeId =
                        this.myVehicle.vehicle_type_id
                    this.theVehicle.structureId = this.myVehicle.structure_id
                })
            } else {
                this.cleanFields()
            }
        },
        cleanFields() {
            this.internal = 0
            Object.keys(this.theVehicle).map(
                (key) => (this.theVehicle[key] = '')
            )
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        async getPeopleList(filters = {}) {
            const clientId = this.client
                ? this.client.id
                : this.myClient
                ? this.myClient.id
                : 0
            if (!clientId) return
            const { data } = await this.$repo.get('people/autocomplete', {
                ...filters,
                clientId,
                search: this.search,
                internal: 1,
            })
            this.people = data.map((item) => ({
                ...item,
                name: `${item.name} (${
                    !!item.structure ? item.structure : 'NA'
                }) - ${!!item.internal ? 'Interno' : 'Visitante'}`,
            }))
        },
    },

    created() {
        this.loadStructures()
        // this.loadVehicleTypes()
        this.load('vehicleTypes')
        this.cleanFields()

        this.$bus.$on('vehicle-form.save', this.SaveOrUpdate)
        this.$bus.$on('vehicle-form.clean', this.cleanFields)
    },
    mounted() {
        this.getPeopleList()
    },
    beforeDestroy() {
        this.$bus.$off('vehicle-form.save')
    },
}
</script>
